import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/form/input-group/input-group.component.js'

const tagName = 'dap-ds-input-group'

/**
 * `dap-ds-input-group`
 * @summary An input group is a container for inputs.
 * @element dap-ds-input-group
 * @title - Input group
 * @group form
 *
 * @property {string} label - The label of the input group.
 * @property {string} description - The description of the input group.
 * @property {string} tooltip - The tooltip of the input group.
 * @property {'top' | 'right' | 'bottom' | 'left'} tooltipPlacement - The tooltip placement of the input group.
 * @property {string} tooltipAriaLabel - The aria label of the tooltip.
 * @property {string} optionalLabel - The label of the input group when it is optional.
 * @property {boolean} disabled - Whether the input group is disabled.
 * @property {'xs' | 'sm' | 'lg'} size - The size of the input group. Default is `sm`. Can be `sm` or `lg`.
 * @property {boolean} required - Whether the input group is required.
 * @property {boolean} optional - Whether the input group is optional.
 * @property {string} feedback - The feedback of the input.
 * @property {string} feedbackType - The type of the feedback.
 * @property {boolean} subtle - Whether the input group label is subtle.
 *
 * @slot - The content of the input group items.
 * @slot feedback-icon - The custom icon of the feedback.
 *
 * @csspart base - The main input group container.
 * @csspart label - The label of the input group.
 * @csspart description - The description of the input group.
 * @csspart tooltip - The tooltip of the input group.
 * @csspart container - The container of the input group items.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSInputGroup',
})

export default reactWrapper
